import { Field } from "@base-ui/react/field";
import { Input as BaseInput } from "@base-ui/react/input";
import * as stylex from "@stylexjs/stylex";
import type { ComponentProps } from "react";
import { controlStyles } from "./control.styles.ts";
export interface InputProps extends Omit<ComponentProps<typeof BaseInput>, "className" | "style"> {
  mono?: boolean;
  invalid?: boolean;
}
export function Input({
  mono = false,
  invalid = false,
  ...rest
}: InputProps) {
  return <BaseInput {...rest} aria-invalid={invalid || undefined} {...stylex.props(controlStyles.base, controlStyles.input, mono && controlStyles.mono, invalid && controlStyles.invalid)} />;
}
export interface TextareaProps extends Omit<ComponentProps<"textarea">, "className" | "style"> {
  mono?: boolean;
  invalid?: boolean;
}

/**
 * Rendered through Base UI's Field control so a surrounding `FormField`
 * labels and describes it (label `for`, `aria-describedby`, invalid state).
 */
export function Textarea({
  mono = false,
  invalid = false,
  rows = 4,
  ...rest
}: TextareaProps) {
  const className = stylex.props(controlStyles.base, controlStyles.textarea, mono && controlStyles.mono, invalid && controlStyles.invalid).className;
  return <Field.Control render={controlProps => <textarea {...controlProps as ComponentProps<"textarea">} {...rest} rows={rows} aria-invalid={invalid || undefined} className={className} />} />;
}